module.exports = __webpack_public_path__ + "assets/a9c72a37aa5991b5e5401b60f99d5632.png";